export const First = require("./info-1.png");
export const Second = require("./info-2.png");
export const Third = require("./info-3.png");
